export default {
  created_date: '2019-07-30T00:00:00.000',
  description: 'Logs for vendor admin',
  name: 'Vendor Logs',
  value: 'vendorlogs',
  viewcolumns: [
    {
      name: 'created_date',
      title: 'Created',
      datatype: 'date'
    },
    {
      name: 'username',
      title: 'User Name',
      datatype: 'string'
    },
    {
      name: 'action',
      title: 'Action',
      datatype: 'string'
    },
    {
      name: 'description',
      title: 'Details',
      datatype: 'string'
    },
    {
      name: 'comment',
      title: 'Comment',
      datatype: 'string'
    }
  ],
  filters: [
    {
      name: 'Created',
      datatype: 'daterange',
      logpropertyname: 'created_date'
    },
    {
      name: 'Action',
      datatype: 'string',
      logpropertyname: 'action'
    },
    {
      name: 'User Name',
      datatype: 'string',
      logpropertyname: 'username'
    }
  ]
};
